<h3 mat-dialog-title>{{ 'DIALOGS.RESERVES.title' | translate }}</h3>
<mat-dialog-content>
  <app-hint class="reserve-hint">
    <span>{{ 'DIALOGS.RESERVES.warning' | translate }}</span>
  </app-hint>
  <app-table [columns]="columns" [dataSource]="dataSource" loadingType="all">

    <ng-container *app-table-header="'courier'">{{ 'RESERVE_CHECK_DIALOG.TABLE.courier' | translate }}</ng-container>
    <ng-container *app-table-header="'count'">{{ 'RESERVE_CHECK_DIALOG.TABLE.count' | translate }}</ng-container>

    <ng-container *app-table-column="let reserve, name:'courier'">
      <app-heading [subtitle]="reserve.sender.name" [title]="reserve.courier.name">
      </app-heading>
    </ng-container>

    <ng-container *app-table-column="let reserve, name:'count'">
      <span [matTooltip]="getTooltip(reserve)"
            [ngClass]="{ 'warning-value': isWarning(reserve), 'critical-value': isCritical(reserve) }">
        {{reserve.remainingCount}}
      </span>
    </ng-container>
  </app-table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button [mat-dialog-close]="interruptResult" color="warn" mat-raised-button>{{ 'COMMON.cancel' | translate }}</button>
  <button [mat-dialog-close]="resumeResult" class="primary-btn-action" color="primary" mat-raised-button>{{ 'COMMON.continue' | translate }}
  </button>
</mat-dialog-actions>
